import { render, staticRenderFns } from "./AdminTreePicker2.vue?vue&type=template&id=28d3c6df&"
import script from "./AdminTreePicker2.vue?vue&type=script&lang=ts&"
export * from "./AdminTreePicker2.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTreePicker2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VMenu,VTextField})
